import { TextTransformService } from '../services/text-transform.service';

export function mapFloatToStringWithComma(value: number, separateThousands: boolean = true): string {
  let transformedValue = String(value.toFixed(2)).replace('.', ',');
  if (separateThousands) {
    transformedValue = TextTransformService.separateValues(transformedValue);
  }
  return transformedValue;
}
